module.exports = __webpack_public_path__ + "static/stormfront-7668e9ceba375303f574013ae77b1921.jpg";